import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "section-select_search" }
const _hoisted_2 = ["onClick"]

import { toRefs, ref, watch, computed } from "vue";
import { GeoPlaceData } from "@/store/modules/GeoPlace/type";
import { OpenGlobal } from "@/store/modules/User/type";
import { useField } from "vee-validate";
import { store } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchComponentLocation',
  props: {
    name: {},
    options: {},
    store: {},
    error: {},
    select: {},
    selectCallback: {}
  },
  setup(__props: any) {

const props = __props;


const data = toRefs(props);

const { value, resetField } = useField(
  data.name?.value || "search-select",
  (value: string) => value
);

const updateSelect = (_value: GeoPlaceData) => {
  resetField({
    value: _value.name,
  });

  store.commit(data.store.value, _value);
  store.dispatch(data.selectCallback.value);
};
const openUserGlobal = ref(
  computed<OpenGlobal>(() => store.getters.getUserOpenElement)
);
const updateOpen = (valueOpen?: boolean) => {
  store.commit("updateUserOpenGlobal", {
    value: valueOpen || !openUserGlobal.value.value,
    name: data.name?.value,
  });
};

watch(
  () => data.options.value,
  () => {
    if (data.options.value.length === 1) {
      store.commit(data.store.value, data.options.value[0]);
      resetField({
        value: data.options.value[0].name,
      });
    } else {
      if (data.options.value[0]?.name)
        resetField({
          value: data.options.value[0].name,
        });
    }
  },
  {
    deep: true,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["select-form select-search b-solid-blue100", { 'error-input country': _unref(data).error.value, 'disabled-select': props.options?.length <= 1 }]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (updateOpen(true)), ["stop"]))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(["text-motserrat-16 text-nowrap", {pointer: props.options?.length > 1}])
      }, _toDisplayString(_unref(value) || _ctx.select), 3),
      _createElementVNode("ul", {
        class: _normalizeClass(["list", {
          hidden:
            !openUserGlobal.value.value || openUserGlobal.value.name !== _unref(data).name?.value || props.options?.length <= 1,
        }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).options.value, (option, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: option.id + i,
            class: "w-100"
          }, [
            _createElementVNode("li", {
              class: "list-item text-motserrat-16",
              onClick: _withModifiers(($event: any) => (updateSelect(option), updateOpen(false)), ["stop"])
            }, [
              _createElementVNode("span", null, _toDisplayString(option.name), 1)
            ], 8, _hoisted_2)
          ]))
        }), 128))
      ], 2)
    ], 2)
  ]))
}
}

})